import { createChildListViewComponent } from 'factories/ChildListView'
import { formatValue } from 'helpers/listViews'
import entityNames from 'options/entityNames'

export default createChildListViewComponent({
  entityName: entityNames.locationCounts,
  childName: 'details',
  allowCreate: (self) => false,
  allowCustomize: (self) => true,
  allowSearching: (self) => true,
  allowSelection: (self) => false,
  allowDelete: (self) => false,
  tableCellComponents: {
    count: (self, { count: value }, { displayFormat, dtoFieldName }) =>
      value > -1
        ? formatValue({
            value,
            displayFormat,
            dtoFieldName,
          })
        : '',
    count2: (self, { count2: value }, { displayFormat, dtoFieldName }) =>
      value > -1
        ? formatValue({
            value,
            displayFormat,
            dtoFieldName,
          })
        : '',
  },
})()
